import { render } from "./PnpExpandingToolbar.vue?vue&type=template&id=b6631842&scoped=true&ts=true"
import script from "./PnpExpandingToolbar.vue?vue&type=script&lang=ts"
export * from "./PnpExpandingToolbar.vue?vue&type=script&lang=ts"

import "./PnpExpandingToolbar.vue?vue&type=style&index=0&id=b6631842&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6631842"]])

export default __exports__